<template>
  <div
    class="container-sort-label"
    @click="onClick"
  >
    <slot/>
    <i :class="icon"/>
  </div>
</template>

<script>
export default {
  name: 'BaseSortLabel',

  props: {
    value: {
      type: String,
      default: null,
      validator: (value) => {
        return [
          'asc',
          'desc',
          null,
        ].includes(value)
      },
    },
  },

  data () {
    return {
      input: null,
    }
  },

  computed: {
    icon () {
      if (this.input === null) {
        return 'fas fa-sort'
      } else if (this.input === 'asc') {
        return 'fas fa-sort-up'
      }
      return 'fas fa-sort-down'
    },
  },

  watch: {
    value (newVal) {
      this.input = newVal
      this.$emit('input', newVal)
    },
  },

  mounted () {
    this.input = this.value
  },

  methods: {
    onClick () {
      if (this.input === 'asc') {
        this.input = 'desc'
      } else if (this.input === 'desc') {
        this.input = 'asc'
      } else {
        this.input = 'asc'
      }
      this.$emit('input', this.input)
      this.$emit('onChange', this.input)
    },
  },
}
</script>

<style scoped>
  .container-sort-label {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
  }

  .container-sort-label i {
    margin-left: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/BaseSortLabel.vue